import styled from 'styled-components/macro';
import { device } from '../../device';



export const StyledCarousel = styled.div`

    overflow:hidden;
    display:flex;
    flex-direction:column;
    align-items:center;
`;

export const Container = styled.div`
    display:flex;
`;

export const Slide = styled.div`
    position:relative;
    min-width:100%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`;


export const DotList = styled.div`

    margin:0;
    padding:0;
    padding-top:10px;
    display:inline-flex;
    justify-content:space-between;
    margin:0 auto;
`;


export const Dot = styled.button`
    border:none;
    padding:0;
    margin:0;
    background-color: ${ props => props.isActive ? '#047961' : '#B6B6B6' };
    border-radius:50%;
    height:7px;
    width:7px;
    margin-right:5px;
    &:last-child {
        margin-right:0;
    }
    
`;